export enum ChannelId {
  CTV = 1,
  OLV = 2,
  Display = 3,
  SpotifyDirect = 4,
  Google = 5,
  Amazon = 6,
  Dooh = 7,
  Gaming = 8,
  Audio = 9,
  GamVideo = 10,
  GamDisplay = 11,
}

export default ChannelId;
